import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import theme from "../../theme";
const useStyles = makeStyles({
  gutter: {
    marginBottom: "20px",
  },
  table: {
    borderTopWidth: 1,
    borderColor: "rgb(151, 151, 151)",
    borderStyle: "solid",
  },
  border: {
    width: "auto",
  },
  first: {
    width: "auto",
  },
  second: {
    width: "33%",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    [theme.breakpoints.between("md", "md")]: {
      width: "40%",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "20%",
    },
    [theme.breakpoints.down("s")]: {
      width: "40%",
    },
  },
});

function createData(name, details) {
  return { name, details };
}

const rows = [
  createData("社　名", "株式会社大国フーズ"),
  createData("所在地", "大阪市生野区田島6丁目14番19号"),
  createData("創　業", "1978年"),
  createData("資本金", "20,000,000円"),
  createData("取引銀行", "尼崎信用金庫　平野支店りそな銀行　生野支店"),
  createData("従業員", "約70名"),
  createData("直営店", "とまと家族：大阪市天王寺区玉造元町10-23"),
  createData("関連会社", "協栄産業株式会社（きのこ類専門商社）"),
];
export default function InfoTable() {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.gutter}>
      <Table className={classes.table} size="small" aria-label="simple table">
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell className={classes.second}>{row.name}</TableCell>
              <TableCell className={classes.border}>{row.details}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
